import React from 'react';
import styled from 'styled-components';

/**
 * "MM" monogram - the compact lock-up for nav bars, favicons, avatars.
 *
 * Two cream M's stacked horizontally with an amber diagonal slash driven
 * through the center. Fits inside a square bounding box so it slots into
 * any 24-48px corner comfortably.
 */

const Svg = styled.svg`
  display: block;
  color: var(--color-cream-100);
`;

const Letter = styled.text`
  font-family: var(--font-display);
  font-weight: 400;
  fill: currentColor;
  letter-spacing: -2px;
`;

const Slash = styled.line`
  stroke: var(--color-amber-500);
  stroke-width: 8;
  stroke-linecap: square;
`;

/**
 * @param {object} props
 * @param {number} [props.size=40] - rendered pixel size (square)
 * @param {string} [props.className] - pass-through className
 */
export const Monogram = ({ size = 40, className }) => {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            width={size}
            height={size}
            role="img"
            aria-label="Movie Mayhem"
            className={className}
        >
            <Letter x="50" y="78" fontSize="96" textAnchor="middle">
                MM
            </Letter>
            <Slash x1="10" y1="88" x2="90" y2="14" />
        </Svg>
    );
};

export default Monogram;
